export const getCategoryListQuery = `
  query ListCategories($input: ListCategoriesInput!) {
    listCategories(input: $input) {
      code
      totalElements
      totalPages
      currentPage
      pageSize
      categories {
        id
        name
        description
        parentId
        path
        depth
        status
        companyId
        createdBy
        createdAt
        updatedBy
        updatedAt
      }
    }
  }
`;

export const createCategoryQuery = `
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      code
      id
    }
  }
`;

export const updateCategoryQuery = `
  mutation UpdateCategory($input: UpdateCategoryInput!) {
    updateCategory(input: $input) {
      code
      id
    }
  }
`;

export const deleteCategoryQuery = `
  mutation DeleteCategory($input: DeleteCategoryInput!) {
    deleteCategory(input: $input) {
      code
    }
  }
`;

////USER - PROFILE

export const getProfileQuery = `
  query GetProfile($input: GetProfileInput!) {
    getProfile(input: $input) {
        user {
            id
            firstName
            lastName
            email
            phone
            profileImage
            role
            companyId
            storeId
        }
        code
    }
  }
`;
